import { useContext } from 'react';

import { CheckoutContext } from '../context/CheckoutContext';

function useCheckoutCtx() {
  const context = useContext(CheckoutContext);

  if (context === undefined) {
    throw new Error(
      'useCheckoutCtx must be used within a CheckoutProvider provider',
    );
  }

  return context;
}

export default useCheckoutCtx;
